import React from 'react';
import { Skeleton } from '@utmost.co/utmost-design-system';
import { StyledSkeletonContainer } from './Styles.css/PolicyLink.styles';

export const PermissionLoadingSkeleton: React.FC = () => {
  return (
    <StyledSkeletonContainer>
      <Skeleton width="270px" height="40px" />
      <Skeleton width="270px" height="30px" />
    </StyledSkeletonContainer>
  );
};
